"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapSharedObjectToAffectedSharedObject = exports.mapGranteesToShareStatus = exports.mapAccessGranteeDetailToGrantee = exports.mapGranteesToAccessGrantees = exports.mapShareStatusToGroupAll = exports.mapUserToInactiveOwner = exports.mapOwnerToGrantee = exports.mapUserFullName = exports.mapWorkspaceUserGroupToGrantee = exports.mapWorkspaceUserToGrantee = void 0;
// (C) 2021 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var util_1 = require("@gooddata/util");
var types_1 = require("./ShareDialogBase/types");
var utils_1 = require("./ShareDialogBase/utils");
var mapUserStatusToGranteeStatus = function (status) {
    if (status === "DISABLED") {
        return "Inactive";
    }
    return "Active";
};
/**
 * @internal
 */
exports.mapWorkspaceUserToGrantee = function (user, currentUserRef) {
    return {
        type: "user",
        id: user.ref,
        name: exports.mapUserFullName(user),
        email: user.email,
        isOwner: false,
        isCurrentUser: sdk_model_1.areObjRefsEqual(user.ref, currentUserRef),
        status: mapUserStatusToGranteeStatus(user.status),
    };
};
/**
 * @internal
 */
exports.mapWorkspaceUserGroupToGrantee = function (userGroup) {
    return {
        id: userGroup.ref,
        type: "group",
        name: userGroup.name,
    };
};
/**
 * @internal
 */
exports.mapUserFullName = function (user) {
    if (user.fullName) {
        return user.fullName;
    }
    return user.firstName + " " + user.lastName;
};
/**
 * @internal
 */
exports.mapOwnerToGrantee = function (user, currentUserRef) {
    return {
        type: "user",
        id: user.ref,
        name: exports.mapUserFullName(user),
        email: user.email,
        isOwner: true,
        isCurrentUser: sdk_model_1.areObjRefsEqual(user.ref, currentUserRef),
        status: "Active",
    };
};
/**
 * @internal
 */
exports.mapUserToInactiveOwner = function () {
    return utils_1.InactiveOwner;
};
/**
 * @internal
 */
exports.mapShareStatusToGroupAll = function (shareStatus) {
    if (shareStatus === "public") {
        return utils_1.GranteeGroupAll;
    }
};
/**
 * @internal
 */
exports.mapGranteesToAccessGrantees = function (grantees) {
    var guard = util_1.typesUtils.combineGuards(types_1.isGranteeGroupAll, types_1.isGranteeUserInactive);
    return grantees
        .filter(function (g) { return !guard(g); })
        .map(function (g) {
        var type = types_1.isGranteeUser(g) ? "user" : "group";
        return {
            granteeRef: g.id,
            type: type,
        };
    });
};
exports.mapAccessGranteeDetailToGrantee = function (accessGranteeDetail, currentUserRef) {
    if (sdk_backend_spi_1.isUserAccess(accessGranteeDetail)) {
        return exports.mapWorkspaceUserToGrantee(accessGranteeDetail.user, currentUserRef);
    }
    else if (sdk_backend_spi_1.isUserGroupAccess(accessGranteeDetail)) {
        return exports.mapWorkspaceUserGroupToGrantee(accessGranteeDetail.userGroup);
    }
};
/**
 * @internal
 */
exports.mapGranteesToShareStatus = function (grantees, granteesToAdd, granteesToDelete) {
    var appliedGrantees = utils_1.getAppliedGrantees(grantees, granteesToAdd, granteesToDelete);
    if (utils_1.hasGroupAll(appliedGrantees)) {
        return "public";
    }
    if (appliedGrantees.length > 0) {
        return "shared";
    }
    return "private";
};
/**
 * @internal
 */
exports.mapSharedObjectToAffectedSharedObject = function (sharedObject, owner, isLockingSupported, isLeniencyControlSupported) {
    var ref = sharedObject.ref, shareStatus = sharedObject.shareStatus, isLocked = sharedObject.isLocked, isUnderStrictControl = sharedObject.isUnderStrictControl;
    return {
        ref: ref,
        shareStatus: shareStatus,
        owner: owner,
        isLocked: !!isLocked,
        isUnderLenientControl: !isUnderStrictControl,
        isLockingSupported: isLockingSupported,
        isLeniencyControlSupported: isLeniencyControlSupported,
    };
};
//# sourceMappingURL=shareDialogMappers.js.map